var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 8.3335H8.6665V7.00016H3.33317V8.3335ZM3.33317 6.3335H11.3332V5.00016H7.33317H3.33317V6.3335ZM3.33317 4.3335H11.3332V3.00016H3.33317V4.3335ZM0.666504 13.6668V1.66683C0.666504 1.30016 0.79706 0.986274 1.05817 0.725163C1.31928 0.464052 1.63317 0.333496 1.99984 0.333496H12.6665C13.0332 0.333496 13.3471 0.464052 13.6082 0.725163C13.8693 0.986274 13.9998 1.30016 13.9998 1.66683V9.66683C13.9998 10.0335 13.8693 10.3474 13.6082 10.6085C13.3471 10.8696 13.0332 11.0002 12.6665 11.0002H3.33317L0.666504 13.6668ZM2.7665 9.66683H12.6665V1.66683H1.99984V10.4168L2.7665 9.66683Z",
    fill: "#2173FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 13.6668V1.66683C0.666504 1.30016 0.79706 0.986274 1.05817 0.725163C1.31928 0.464052 1.63317 0.333496 1.99984 0.333496H12.6665C13.0332 0.333496 13.3471 0.464052 13.6082 0.725163C13.8693 0.986274 13.9998 1.30016 13.9998 1.66683V9.66683C13.9998 10.0335 13.8693 10.3474 13.6082 10.6085C13.3471 10.8696 13.0332 11.0002 12.6665 11.0002H3.33317L0.666504 13.6668ZM2.7665 9.66683H12.6665V1.66683H1.99984V10.4168L2.7665 9.66683Z",
    fill: "#04245C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.4e3ca0fc390208937ec2ddcf225b08b1.svg";
export { ForwardRef as ReactComponent };